import React, { useContext, useEffect, useState } from 'react';

import './EqpgsSubtabla.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackspace } from "@fortawesome/free-solid-svg-icons";

import SelectControl from '../SelecControl/SelectControl.jsx';

import FormEqpg from '../FormEqpg/FormEqpg.js';

import eqpgContext from '../../context/eqpgContext/eqpgContex.js';
import { estructuraEqpg } from '../../utils/estructuras.js';
import { SECUNDARY_COLOR } from '../../constants/colors';

const EqpgsSubtabla = ({eqpgs, setState, tablaSeleccionada, tDocID='', checkboxMode=false}) =>{

    const [data,setData] = useState('');
    const [showAddEqpg,setShowAddEqpg] = useState(false);
    const [nuevoEditado, setNuevoEditado] = useState("Agregar");
    const [indexToUpdate,setIndexToUpdate] = useState(-1);
    const [options,setOptions] = useState([]);

    const eContext = useContext(eqpgContext);
    const {actualizarEqpgLista,eqpgIDLista} = eContext;

    const minimizar = () => {
        setShowAddEqpg(false);
    }

    const createOptions = () => {
        const copyEqpgs = JSON.stringify(eqpgIDLista)
        const eqpgsList = JSON.parse(copyEqpgs)
        let optionsE = [];
        if(eqpgsList.length > 0){
            optionsE = eqpgsList.map((e) => {return {
                label:e.name, value: e.codEqpg, id: e['_id'], name:e.name
            }})
        }
        setOptions({opcionesEqpgs:optionsE});
    }

    // === Funciones modo tradicional (dropdown) ===
    const handleChangeEqpgs = (eqpg = {},i,textAdic = undefined) => {
        setState((prevState) => {
            let preEqpgs = prevState.eqpgs.slice();
            const copyEqpgs = JSON.stringify(preEqpgs)
            const eqpgsArr = JSON.parse(copyEqpgs)

            if(textAdic != undefined && Object.keys(eqpg).length == 0){
                if(eqpgsArr[i].value !== ''){
                    eqpgsArr[i].textAdic = textAdic;
                }
                let newState = {...prevState,['eqpgs']:eqpgsArr};
                return newState;
            }else{
                if(Object.keys(eqpg).length == 0){
                    eqpgsArr.splice(i,1);
                }
                else if(eqpgsArr[i].value !== ''){
                    eqpgsArr[i] = eqpg;
                    eqpgsArr[i].textAdic = "";
                }else{
                    eqpgsArr[i] = eqpg;
                    eqpgsArr[i].textAdic = "";
                    eqpgsArr.push({...estructuraEqpg});
                }
                let newState = {...prevState,['eqpgs']:eqpgsArr};
                return newState;
            }
        })
    }

    const handleDeleteEqpg = (eqpg,index) => {
        setState((prevState) => {
            let eqpgsArr = prevState.eqpgs.slice();
            if(eqpgsArr.length > 0 && index > -1 && eqpg.label !== ''){
                eqpgsArr = prevState.eqpgs.filter((e,i) => i !== index);
            }
            let newState = {...prevState,['eqpgs']:eqpgsArr};
            return newState;
        });
    }

    // === Funciones modo checkbox ===
    const findCheckedEqpg = (catalogEqpg) => {
        if(!eqpgs || eqpgs.length === 0) return null;
        return eqpgs.find(e => e.value === catalogEqpg.codEqpg || e.codEqpg === catalogEqpg.codEqpg);
    }

    const handleToggleEqpg = (catalogEqpg, checked) => {
        setState((prevState) => {
            let currentEqpgs = prevState.eqpgs ? prevState.eqpgs.filter(e => e.label !== '') : [];

            if(checked) {
                const existing = currentEqpgs.find(e => e.value === catalogEqpg.codEqpg || e.codEqpg === catalogEqpg.codEqpg);
                if(!existing) {
                    currentEqpgs.push({
                        value: catalogEqpg.codEqpg,
                        label: catalogEqpg.name,
                        id: catalogEqpg._id,
                        codEqpg: catalogEqpg.codEqpg,
                        name: catalogEqpg.name,
                        textAdic: ''
                    });
                }
            } else {
                currentEqpgs = currentEqpgs.filter(e =>
                    e.value !== catalogEqpg.codEqpg && e.codEqpg !== catalogEqpg.codEqpg
                );
            }

            return {...prevState, eqpgs: currentEqpgs};
        });
    }

    const handleChangeTextAdic = (catalogEqpg, textAdic) => {
        setState((prevState) => {
            let currentEqpgs = prevState.eqpgs ? prevState.eqpgs.slice() : [];
            const index = currentEqpgs.findIndex(e => e.value === catalogEqpg.codEqpg || e.codEqpg === catalogEqpg.codEqpg);
            if(index > -1) {
                currentEqpgs[index] = {...currentEqpgs[index], textAdic};
            }
            return {...prevState, eqpgs: currentEqpgs};
        });
    }

    const handleChangeEqpgsCheckbox = (eqpg = {}, index) => {
        if(Object.keys(eqpg).length === 0) {
            setState((prevState) => {
                let currentEqpgs = prevState.eqpgs ? prevState.eqpgs.slice() : [];
                currentEqpgs = currentEqpgs.filter(e =>
                    e.value !== data.value && e.codEqpg !== data.codEqpg
                );
                return {...prevState, eqpgs: currentEqpgs};
            });
        } else {
            setState((prevState) => {
                let currentEqpgs = prevState.eqpgs ? prevState.eqpgs.slice() : [];
                const idx = currentEqpgs.findIndex(e => e.id === eqpg.id || e.value === eqpg.value);
                if(idx > -1) {
                    currentEqpgs[idx] = {...currentEqpgs[idx], ...eqpg};
                }
                return {...prevState, eqpgs: currentEqpgs};
            });
        }
    }

    useEffect(()=>{
        createOptions();
    },[eqpgIDLista])

    return <div className={`${(tablaSeleccionada != 'eqpgs') && 'inactive'} eqpgsDiv`}>
    <label>Equipamiento de Protección Grupal (EQPG)</label>
    <div className="eqpgsXtransactionDoc">
        {checkboxMode ? (
            // === MODO CHECKBOX ===
            <>
            {(!eqpgIDLista || eqpgIDLista.length === 0) ? <div style={{display:'flex', alignItems:'center', gap:'0.5rem'}}>
                <h5 style={{marginBottom:0}}>No hay EQPGs cargados en el sistema.</h5>
                <button className="button-add-form" style={{backgroundColor: SECUNDARY_COLOR, borderRadius:'5px', padding:'0.25rem 1rem', fontSize:'1.2rem'}} onClick={() => { setNuevoEditado("Agregar"); setData(''); setShowAddEqpg(true); }}>+</button>
            </div> :
            eqpgIDLista.map((catalogEqpg, i) => {
                const checkedEqpg = findCheckedEqpg(catalogEqpg);
                const checked = !!checkedEqpg;
                return <div className="eqpgDiv" key={`${catalogEqpg.codEqpg}-${i}`}>

                    <SelectControl placeholder={"Seleccione un EQPG..."} modo={"Nuevo"} setShowAdd={setShowAddEqpg} idSelect={"eqpg"} handleChengeSelect={()=>{}} optionsSelect={options.opcionesEqpgs} valueSeleccionada={{value: catalogEqpg.codEqpg, label: catalogEqpg.name, id: catalogEqpg._id, name: catalogEqpg.name}} tipo={'eqpgOT'} selectSelect={()=>{}} setData={setData} index={i} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate} />

                    <label className='customCheckbox'>
                        <input value={checked} className='checkboxTask' type='checkbox' checked={checked} onChange={(e) => handleToggleEqpg(catalogEqpg, e.target.checked)}/>
                        <span className={`${checked ? 'checked' : ''}`}></span>
                    </label>

                    <input className="inputTextAdic" name="textAdic" value={checked ? (checkedEqpg.textAdic || '') : ''} onChange={(e) => handleChangeTextAdic(catalogEqpg, e.target.value)} placeholder="Ingrese texto adicional..." disabled={!checked}/>
                </div>
            })
            }
            </>
        ) : (
            // === MODO TRADICIONAL (DROPDOWN) ===
            <>
            {(eqpgs == undefined) ? <h5>Cargando EQPGs...</h5> :
            eqpgs.length > 0 && eqpgs.map((eqpg,i) =><div className="eqpgDiv" key={`${eqpg.codEqpg}-${i}`}>
                <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '80px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDeleteEqpg(eqpg,i)} />

                <SelectControl placeholder={"Seleccione un EQPG..."} modo={"Nuevo"} setShowAdd={setShowAddEqpg} idSelect={"eqpg"} handleChengeSelect={handleChangeEqpgs} optionsSelect={options.opcionesEqpgs} valueSeleccionada={eqpg} tipo={'eqpgOT'} selectSelect={handleChangeEqpgs} setData={setData} index={i} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate} />

                <input className="inputTextAdic" name="textAdic" value={eqpg.textAdic} onChange={(e) => handleChangeEqpgs({},i,e.target.value)} placeholder="Ingrese texto adicional..."/>
            </div>)
            }
            </>
        )}
        {showAddEqpg && <FormEqpg data={data} setData={setData} minimizar={minimizar} nuevoEditado={nuevoEditado} handleChangeEqpgs={checkboxMode ? handleChangeEqpgsCheckbox : handleChangeEqpgs} index={indexToUpdate} tDocID={tDocID}/> }
    </div>
    </div>
}

export default EqpgsSubtabla;
